import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import useSound from 'use-sound';

// project imports
import notiSound from '../../assets/music/noti.wav';
import LogoSection from '../LogoSection';


// assets
import { IconMenu2,IconCoin } from '@tabler/icons';
import { useEffect, useRef, useState } from 'react';
import jwtDecode from 'jwt-decode';
import axios from '../apiClient';
import Alert from '../alert';
import { useNavigate } from 'react-router';
import {useLang} from '../../context'
import { Button } from 'antd';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import { io } from 'socket.io-client';
import config from '../../config';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const [amount,setAmount] = useState(0);
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const [agentName,setAgentName] = useState('')
    const {lang, changeLang, text} =  useLang();
    const [notiCount, setNotiCount] =  useState(Number(localStorage.getItem("notiCount") || 0));
    const navigate = useNavigate()

    
    // get data from backend when componenet is first mounted
  async function fetchData() {
    const token = localStorage.getItem("token");
    const {id: holderId,name} = jwtDecode(token)

    let data = await axios.get(`/wallet/getAmount?holderId=${holderId}`)
    if (data.code != 200) {
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        return
    }
    setAmount(data.data.amount)
    setAgentName(name)
  }

  async function handleRefresh() {

    let res = await axios.post(`/wallet/setWithdrawAmountFromDefaultAmount`)
    if (res.code == 200) {
        const amount = res?.data?.currentAmount;
        if(Number(amount) > 0) setAmount(amount)
    }
  }
  //--------------------------------------------------
    const socketRef = useRef();
    const [playNoti] = useSound(notiSound);
    const hiddenDivRef = useRef(null);

    

    useEffect(()=>{
        
        const triggerSound = () => {
            if (hiddenDivRef.current) {
              hiddenDivRef.current.click();
            }
        };
        socketRef.current = io(config.socketApi,{
            auth: {
                token: localStorage.getItem("token")
            },
        });
        socketRef.current.io.on("error", (error) => {
        // console.log("error from socket",error)
        });
    
        socketRef.current.on('withdraw',()=> {
            triggerSound();
            const currentCount = Number(document.getElementById('noti')?.innerHTML || "0");
            const updatedCount = currentCount + 1;
            localStorage.setItem("notiCount",updatedCount);
            if(document.getElementById('noti')){
                document.getElementById('noti').innerHTML = updatedCount;
            }else{
                setNotiCount(updatedCount);
            }
        });
        fetchData();

        return () => {
            socketRef.current.off('withdraw');
        };
    },[])
    const theme = useTheme();
    const handleCloseAlert =()=>{
        setOpenAlert(false)
    }
    const handleLogout = () =>{
        localStorage.removeItem("token");
        navigate('/login')
    }
    
    return (
        <>
           <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
            {/* logo & toggler button */}
            <div
                ref={hiddenDivRef}
                style={{ display: 'none' }}
                onClick={playNoti}
            />
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            {/* <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} /> */}
             <div style={{display: "flex",justifyContent: "space-between",alignItems: "center",width: "100%"}}>
                 <h3 style={{marginLeft: "2rem"}} >Agent Dashboard</h3>
                  <div style={{display: "flex",justifyContent: "space-between",alignItems: "center"}}>
                     <FormControl component="fieldset" style={{marginRight: "40px"}}>
                        <RadioGroup row aria-label="language" name="language" value={lang} onChange={(e) => changeLang(e.target.value)}>
                            <FormControlLabel value="en" control={<Radio   />} label="En" />
                            <FormControlLabel value="uni" control={<Radio   />} label="Uni" />
                            <FormControlLabel value="zg" control={<Radio   />} label="Zg" />
                        </RadioGroup>
                    </FormControl>
                      <div style={{display: "flex",alignItems: "center"}}>
                          <IconCoin color='#0E8388'/>
                          <h3 style={{marginRight: "10px"}}><span style={{fontWeight: 'normal'}}>{text['Units']}:</span><span style={{fontWeight: 'bold',marginLeft: "0.2rem"}}>{Number(amount).toLocaleString()}</span> </h3>
                      </div>
                      <ButtonBase style={{marginRight: "80px",backgroundColor: "rgb(221 221 220)",borderRadius: "40px"}} type='dashed' onClick={()=> handleRefresh()}>
                        <RefreshOutlinedIcon style={{color: "#673ab7"}}/>
                     </ButtonBase>

                      <h3 style={{marginRight: "1rem",fontWeight: 'bold'}}>{agentName}</h3>
                      <ButtonBase style={{position: "relative"}} onClick={()=>{
                        navigate('/member-management/withdrawRequests');
                        localStorage.setItem("notiCount",0);
                        setNotiCount(0)
                      }}>
                        {/* <img src={require("../../assets/icons/bell.svg").default} style={{width: "2.5rem",height: "2.5rem",color: "rgb(103, 58, 183)"}}/> */}
                        <CircleNotificationsIcon style={{width: "2.5rem",height: "2.5rem",color: "#673AB7"}}/>
                        {notiCount > 0 && <div style={{width: "1rem",height: "1rem",backgroundColor: "#E25050",borderRadius: "4.1rem",position:"absolute",left: "60%",top: 0}}>
                            <h1 id='noti' style={{fontSize: "0.9rem",textAlign: "center",margin: 0}} className='white'>{notiCount}</h1> 
                        </div>}
                    </ButtonBase>
                      <ButtonBase style={{marginRight: "1rem",marginLeft: "5rem",borderRadius: "1rem"}} onClick={handleLogout}>
                          <h3>{text['Logout']}</h3>
                      </ButtonBase>
                  </div>
             </div>
            {/* <ProfileSection /> */}
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
